export default "__VITE_ASSET__BwQiGyl$__"